import ImageFragment from 'js/graphqlFragments/ImageFragment';

const fetchData =  `
    {
    themeGeneralSettings {
      Options {
        bannerTitleServices
        bannerContentServices
        ctaButtonServices {
          url
          title
          target
        }
        imageUploadServices {
          ...ImageFragmentServices
        }
      }
    }
  }
  
 ${ImageFragment('Services')}
`;
export default fetchData;
